export default "__VITE_ASSET__BKTYkX0N__"